import React from 'react';

function DeviseFeature({ isMobile, t }) {
  return (
    <section
      style={{
        marginTop: 200,
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'start',
              borderRadius: 18,
              padding: 18,
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? 24 : 30,
              alignItems: isMobile ? 'stretch' : 'center'
            }}
          >
            <div style={{ 
              minWidth: isMobile ? '100%' : 250, 
              width: isMobile ? '100%' : 250,
              order: isMobile ? 2 : 0
            }}>

              {/* Liste de devises */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[
                  { code: 'DZD', flag: '🇩🇿' },
                  { code: 'EGP', flag: '🇪🇬' },
                  { code: 'ERN', flag: '🇪🇷' },
                  { code: 'ETB', flag: '🇪🇹' },
                  { code: 'EUR', flag: '🇪🇺', active: true },
                  { code: 'FJD', flag: '🇫🇯' },
                  { code: 'FKP', flag: '🇫🇰' },
                  { code: 'GBP', flag: '🇬🇧' },
                  { code: 'GEL', flag: '🇬🇪' },
                ].map((item, idx) => (
                  <div
                    key={item.code + idx}
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 0,
                      paddingLeft: 15,
                      backgroundColor: item.active ? '#6450e8' : '#1f2937',
                      borderRadius: 18,
                      padding: '6px 8px',
                      border: item.active ? '1px solid #7c6bf0' : '1px solid rgba(148, 163, 184, 0.25)',
                      color: '#e5e7eb',
                      fontFamily: 'Poppins-Medium',
                      fontSize: '1rem',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                    }}
                    >
                      <span style={{
                        position: 'absolute',
                        left: 20,
                        fontSize: '1.1rem',
                        width: 24,
                        textAlign: 'left'
                      }}>{item.flag}</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{item.code}</span>
                    </div>
                ))}
              </div>
            </div>
            <div style={{ 
              flex: 1, 
              alignItems: 'flex-center', 
              justifyContent: 'flex-center', 
              maxWidth: 400,
              order: isMobile ? 1 : 0,
              textAlign: isMobile ? 'center' : 'left'
            }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: isMobile ? '1.6rem' : '2rem',
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'center',
                }}
              >
                {t.DevisesTitle}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: isMobile ? '1rem' : '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6,
                  textAlign: 'center',
                }}
              >
                {t.DevisesText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DeviseFeature;
